(() => {

    const HEADER = document.querySelector('.header')
    const WRAPPER = document.querySelector('.header-wrapper')

    if(!HEADER || !WRAPPER) return

    let y = window.scrollY

    // Set header height based on wrapper
    HEADER.style = `height: ${WRAPPER.getBoundingClientRect().height }px;`

    function sticky() {

        let HEADER_HEIGHT = HEADER.getBoundingClientRect().height

        let stickyMethod = (window.scrollY > HEADER_HEIGHT * 2) ? 'add' : 'remove'
        let visibleMethod= (y > window.scrollY) ? 'add' : 'remove'

        if(visibleMethod === 'add') stickyMethod = visibleMethod

        HEADER.classList[stickyMethod]('sticky')
        HEADER.classList[visibleMethod]('visible')

        // Account for animation
        setTimeout(() => {
            HEADER.classList[stickyMethod]('fixed')
        }, 150)

        y = window.scrollY
    }

    window.addEventListener('scroll', sticky)

})()
